import React from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import ClaimPaymentFields from "./ClaimPaymentFields";

const ClaimPayoutDetailsDialog = ({ dialogState, setDialogState, onSaved, claimType = "vat" }) => {
  const { t } = useTranslation();
  const { isOpen, claim } = dialogState;

  const handleClose = () => {
    setDialogState({ isOpen: false, claim: null });
  };

  return (
    <Dialog open={isOpen} onClose={handleClose} maxWidth="sm" fullWidth aria-labelledby="claim-payout-details-title">
      <DialogTitle id="claim-payout-details-title">
        {t("Received payment details")} — {claim?.claimCode}
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          {t("Enter the date and amount when payment was received for this claim.")}
        </Typography>
        {claim?.claimId ? (
          <ClaimPaymentFields
            claimId={claim.claimId}
            claimType={claimType}
            paymentReceivedDate={claim.paymentReceivedDate ?? claim.PaymentReceivedDate}
            paymentAmount={claim.paymentAmount ?? claim.PaymentAmount}
            onSaved={onSaved}
            onSaveSuccess={handleClose}
          />
        ) : null}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>{t("Close")}</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ClaimPayoutDetailsDialog;
